import React from 'react';
import PropTypes from 'prop-types';
import {Select} from 'antd';
import {injectIntl} from 'react-intl';
import LabelFilter from "./label-filter";

const { Option } = Select;


class LabelsFilter extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    labelType: PropTypes.string,
    labelValues: PropTypes.object.isRequired,
  }

  onLabelTypeChange = (labelType) => {
    this.props.onChange(labelType, {});
  }

  onLabelChange (label, value) {
    const { labelType } = this.props;
    let labelValues = Object.assign({}, this.props.labelValues);
    if (!value) {
      delete labelValues[label];
    } else {
      labelValues[label] = value;
    }
    this.props.onChange(labelType, labelValues);
  }

  getOnLabelChange(label) {
    return (value) => {
      this.onLabelChange(label, value);
    }
  }

  render() {
    const { labelType, labelValues } = this.props;
    const { formatMessage } = this.props.intl;
    return (<div className="audit__filters-container" style={{ marginBottom: '10px'}}>
      <label>
        <Select
          placeholder={formatMessage({id: 'analytics.url-labels', defaultMeassage: 'Url labels'})}
          style={{ width: '100px',  marginRight: '5px' }}
          allowClear={true}
          onChange={this.onLabelTypeChange}
          value={labelType}
        >
          <Option value='utm'>UTM</Option>
          <Option value='openstat'>Openstat</Option>
        </Select>
      </label>
      { labelType === 'utm' && (
        <span className="audit__utm-container">
        <LabelFilter
          placeholder={'utm_source'}
          labelType='utm' labelName='utm_source'
          labelValue={labelValues.utm_source}
          onChange={this.getOnLabelChange('utm_source')}
        />
        <LabelFilter
          placeholder={'utm_medium'}
          labelType='utm' labelName='utm_medium'
          labelValue={labelValues.utm_medium}
          onChange={this.getOnLabelChange('utm_medium')}
        />
        <LabelFilter
          placeholder={'utm_campaign'}
          labelType='utm' labelName='utm_campaign'
          labelValue={labelValues.utm_campaign}
          onChange={this.getOnLabelChange('utm_campaign')}
        />
        <LabelFilter
          placeholder={'utm_term'}
          labelType='utm' labelName='utm_term'
          labelValue={labelValues.utm_term}
          onChange={this.getOnLabelChange('utm_term')}
        />
        <LabelFilter
          placeholder={'utm_content'}
          labelType='utm' labelName='utm_content'
          labelValue={labelValues.utm_content}
          onChange={this.getOnLabelChange('utm_content')}
        />
        </span>)
      }
      { labelType === 'openstat' && (
        <span className="audit__openstat-container">
        <LabelFilter
          placeholder={'service'}
          labelType='openstat' labelName='service'
          labelValue={labelValues.service}
          onChange={this.getOnLabelChange('service')}
        />
        <LabelFilter
          placeholder={'campaign'}
          labelType='openstat' labelName='campaign'
          labelValue={labelValues.campaign}
          onChange={this.getOnLabelChange('campaign')}
        />
        <LabelFilter
          placeholder={'ad'}
          labelType='openstat' labelName='ad'
          labelValue={labelValues.ad}
          onChange={this.getOnLabelChange('ad')}
        />
        <LabelFilter
          placeholder={'source'}
          labelType='openstat' labelName='source'
          labelValue={labelValues.source}
          onChange={this.getOnLabelChange('source')}
        />
        </span>)
      }
    </div>)
  }
}


export default injectIntl(LabelsFilter);


// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/labels-filter.js